module.exports = __webpack_public_path__ + "static/media/Delayed truck 1.c1946df6.svg";